module.exports = __webpack_public_path__ + "img/ins.2d709867.png";